import React from 'react';
import styled from 'styled-components';

import Pin from '../components/Pin';

const ScreenWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  background: #192842;
`;

const PinScreen = () => (
  <ScreenWrapper>
    <Pin />
  </ScreenWrapper>
);

export default PinScreen;
